function thumbnailChange() {
    $(".product-thumbnails .thumbnail--media-image").on( "click", function(e) {
        e.preventDefault();
        $(this).addClass("selected");
        $(this).siblings().removeClass("selected");
        const mediaId = $(this).attr("data-media-id");
        var slideIndex = $('.slick-slider').find('[data-media-id="' + mediaId + '"]').closest('.slick-slide').data('slick-index');
        $('.slick-slider').slick('slickGoTo', slideIndex);
    });  
}